import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {Institution} from '../interface/institution';

@Injectable({
  providedIn: 'root'
})
export class InstitutionService {

  private baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  get(id: number): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/institution/${id}`);
  }

  getCollection(): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/institutions`);
  }

  create(data: any): Observable<any>{
    return this.http.post(`${this.baseUrl}/create/institution`, data);
  }

  edit(id: number, data: any): Observable<any>{
    return this.http.post(`${this.baseUrl}/edit/institution/${id}`, data);
  }

  delete(id: number): Observable<any>{
    return this.http.delete(`${this.baseUrl}/delete/institution/${id}`);
  }

  deleteMultipleInstitutions(ids: number[]): Observable<Institution[]>{
    const options = {body: ids};
    return this.http.delete<any>(`${this.baseUrl}/delete/states`, options);

  }

}
